import TopNavBar from "../../components/topNavBar.mjs";
import Snackbar from "../../components/snackbar.mjs";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

export default function CreateAvatarPage() {
    const [hasSetup, setHasSetup] = useState(false); // Boolean, page rendering

    const [authToken, setAuthToken] = useState("");
    window.addEventListener('message', streamojiListener);
    document.addEventListener('message', streamojiListener);
    
	const keygenID = sessionStorage.getItem('keygenID');
	const userToken = sessionStorage.getItem('userToken');
	const firstName = sessionStorage.getItem('firstName');
	const lastName = sessionStorage.getItem('lastName');
    const navigate = useNavigate();

    // React way to handle functions
    const displayIframe = async () => {
        const frame = document.getElementById('frame');
        let src = 'https://avatars.streamoji.com/createAvatar?iframe=true&bodyType=Half&whiteLabelTitle=syGlass%20Avatar%20Creator&whiteLabelColor=%2322ACE2';
        if (authToken) {
            src += '&token=' + authToken;
            frame.src = src;
            frame.hidden = false;
        }
    };

    const uploadAvatar = async (avatarURL) => {
		await fetch("/uploadAvatar/", {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ userID: keygenID, token: userToken, url: avatarURL.toString(), fName: firstName, lName: lastName }),
		})
		.then(response => response.json())
		.then(data => {
			if (data === "Not Authorized") {
				sessionStorage.clear();
				navigate("/");
				return;
			}

			if (data.httpStatusCode !== undefined && data.httpStatusCode === 200) {
				Snackbar("cmdSent", 5000);
			}  else {
				Snackbar("wentWrongAvatar", 5000);
			}
		})
		.catch(error => console.log(error));
	}

    async function streamojiListener(event) {
        const json = parse(event);
        const frame = document.getElementById('frame');

        if (json?.source !== 'streamojiavatars') {
            return;
        }

        if (json.eventName === 'v1.frame.ready') {
            frame.contentWindow.postMessage(
                JSON.stringify({
                    target: 'streamojiavatars',
                    type: 'subscribe',
                    eventName: 'v1.**'
                }),
                '*'
            );
        }
        if (json.eventName === 'v1.avatar.exported') {
            const url = json.data.url;
            let finalUrl = '';
            try {
                const urlObj = new URL(url);
                const filename = urlObj.pathname.split('/').pop(); 
                const avatarId = filename.replace('.glb', '');
                finalUrl = `https://glb.streamoji.com/api/process?avatarId=${avatarId}`;
            } catch (e) {
                finalUrl = url;
            }
            frame.hidden = true;
            await uploadAvatar(finalUrl);
        }
    }

    function parse(event) {
        try {
            return JSON.parse(event.data);
        } catch (error) {
            return null;
        }
    }

    
    const FetchToken = async () => {
        setAuthToken(await fetch("https://sybackend.net/avatarToken", {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
                'Syg-Client-Secret': 'syGlass_Streamoji_Avatars'
			},
			body: JSON.stringify({ 
                userId: keygenID,
                userName: firstName + " " + lastName,
                maxAvatarCreations: 1
            }),
		})
        .then(response => response.json())
        .then(data => {
            if (!data?.authToken) {
                Snackbar("wentWrongToken", 5000);
            }
            return data?.authToken ?? "";
        })
        .catch(error => {
            console.log(error)
            Snackbar("wentWrongToken", 5000);
        }));
    }
    
    if (!hasSetup) {
        FetchToken()
        setHasSetup(true);
    }

  return (
    <>
      <div>
        <TopNavBar />
      </div>
      <div className="page">
        <div style={{height:'70px', width:'1120px', marginBottom:'50px'}}></div>
		<br></br>
		
        <div className="snackbarRed" id="wentWrongAvatar">Failed to save avatar</div>
        <div className="snackbarRed" id="wentWrongToken">Failed to fetch avatar creation token</div>
        <div className="snackbarNormal" id="cmdSent">Avatar saved successfully!</div>

        <p style={{fontSize:'18px'}}>syGlass Avatar Creator</p>
        <div style={{fontSize:'14px'}}>
            <p style={{margin:'10px 0px'}}>Click the "Open Avatar Editor" button</p>
            <p style={{margin:'10px 0px'}}>Click the "Save" button when you're done customizing</p>
            <p style={{margin:'10px 0px'}}>You can save one avatar every 24 hours</p>
        </div>
        
        <input 
          type="button" 
          value="Open Avatar Editor" 
          onClick={displayIframe} 
          style={{ padding: '10px', color: '#161d2c', backgroundColor: '#22ace2', border: 'none', borderRadius: '8px', fontWeight: 'bold' }}
          hidden={authToken.length === 0}
        />
        
        <iframe 
          id="frame"
          allow="camera *; microphone *; clipboard-write" 
          style={{ width:'1800px', height:'1080px', margin:'0', padding:'20px', fontSize:'14px', border:'none', maxWidth: '80vw', paddingLeft: '0px' }} 
          hidden={true}
        />
      </div>
    </>
  );
}